<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />

    <section class="filter-dropdown">
      <div class="modal-header">
        <div class="is-flex is-justify-content-space-between">
          <div class="subtitle has-text-weight-semibold">
            {{ General.FILTERS }}
          </div>
          <div class="cursor-pointer" @click.stop="close">
            <b-icon icon="close-circle" type="is-grey-light" />
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div
          v-for="(item, index) in currentFilterList"
          :key="index"
          class="columns is-mobile is-vcentered mb-0 "
        >
          <b-select
            v-model="currentFilterList[index].type"
            :placeholder="General.SELECT_FILTER"
            expanded
            class="column is-4 pr-5"
            @input="value => onSelectOption(value, index)"
          >
            <option
              v-for="(option, indexOptions) in checkSelect(index)"
              :key="indexOptions"
              :value="option.type"
            >
              {{ option.name }}</option
            >
          </b-select>
          <div class="column is-7 pl-5">
            <b-autocomplete
              v-if="currentFilterList[index].type === `ORIGIN`"
              v-model="currentFilterList[index].data.displayText"
              :data="getFilteredParts(filterPartTo)"
              field="name"
              expanded
              @typing="setFilterPartTo"
              @select="value => onSelectData(value, index)"
            />
            <b-autocomplete
              v-else-if="currentFilterList[index].type === `ORIGIN_CAPACITY`"
              v-model="currentFilterList[index].data.displayText"
              :data="getCapacitiesFiltered(filterCapacityTo)"
              field="name"
              expanded
              @typing="setFilterCapacityTo"
              @select="value => onSelectData(value, index)"
            />
            <b-dropdown
              v-else-if="currentFilterList[index].type === `DATE`"
              :ref="datekey"
              expanded
              appendToBody
            >
              <template slot="trigger">
                <b-button
                  iconLeft="calendar"
                  class="is-justify-content-flex-start"
                  expanded
                  ><span
                    v-if="
                      currentFilterList[index].data &&
                        currentFilterList[index].data.start
                    "
                    ><span>{{
                      currentFilterList[index].data.start
                        | dateFormat("DD/MM/YYYY")
                    }}</span>
                    -
                    <span>{{
                      currentFilterList[index].data.end
                        | dateFormat("DD/MM/YYYY")
                    }}</span></span
                  ><span v-else>{{ General.DATE }}</span></b-button
                >
              </template>
              <b-dropdown-item custom>
                <DatePicker
                  isRange
                  :locale="locationConfig"
                  :value="dateRange"
                  :modelConfig="modelConfig"
                  @input="value => onSelectData(value, index)"
                />
              </b-dropdown-item>
            </b-dropdown>
            <b-autocomplete
              v-else-if="currentFilterList[index].type === `SUBJECT`"
              v-model="currentFilterList[index].data.completeName"
              :data="getSubjects"
              field="completeName"
              expanded
              :loading="isFetching[index]"
              @typing="text => setFilterSubject(text, index)"
              @select="value => onSelectData(value, index)"
            >
              <template slot-scope="props">
                <div class="media pre-wrap">
                  <div class="media-content">
                    {{ props.option.completeName }}
                  </div>
                </div>
              </template>
            </b-autocomplete>
            <b-input
              v-else-if="currentFilterList[index].type === `REFERENCE_NUMBER`"
              v-model="currentFilterList[index].data.displayText"
              :placeholder="General.PLACEHOLDER.TYPE_SEARCH_PROCESS_REFERENCE"
              expanded
            />
            <b-input v-else expanded disabled />
          </div>
          <div
            class="column is-1 pl-0 cursor-pointer"
            @click.stop="
              checkSingleFilter(index)
                ? clearFilter(index)
                : removeFilter(index)
            "
          >
            <b-icon
              icon="minus-circle-outline"
              :type="checkSingleFilter(index) ? `is-grey` : ``"
            />
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column new-filter-wrapper">
            <div class="cursor-pointer new-filter" @click.stop="addFilter()">
              <b-icon icon="plus-circle" type="is-primary"></b-icon>
              <span class="has-text-weight-semibold">{{
                General.ADD_FILTER
              }}</span>
            </div>
          </div>
          <div class="column is-1"></div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="buttons mt-20">
          <b-button
            class="has-text-weight-semibold"
            type="is-primary"
            @click.stop="applyFilters"
            >{{ General.APPLY.toUpperCase() }}</b-button
          >
          <b-button
            class="has-text-weight-semibold"
            type="is-primary"
            outlined
            @click.stop="close"
            >{{ General.CANCEL.toUpperCase() }}</b-button
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { mapActions, mapGetters } from "vuex";
import { App, General } from "@/utils/constants";
import { v4 as uuidv4 } from "uuid";
import { debounce } from "lodash";

export default {
  name: "ModalFilterConsultProcess",

  components: {
    DatePicker
  },

  props: {
    itensFilter: {
      type: Array,
      default: () => [
        "ORIGIN",
        "ORIGIN_CAPACITY",
        "DATE",
        "SUBJECT",
        "REFERENCE_NUMBER"
      ]
    },
    onApply: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      isFetching: [],
      locationConfig: Object.freeze({
        id: "pt-br",
        firstDayOfWeek: 1,
        masks: { input: `YYYY-DD-MM` }
      }),
      modelConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      filterPartTo: "",
      filterCapacityTo: "",
      currentFilterList: "",
      filterSubject: "",
      dateRange: { start: new Date(), end: new Date() },
      options: [
        { name: General.REGISTRATION_ORGAN, type: "ORIGIN" },
        { name: General.ORIGIN_UNITY, type: "ORIGIN_CAPACITY" },
        { name: General.PERIOD, type: "DATE", unique: true },
        { name: General.SUBJECT, type: "SUBJECT" },
        { name: General.EXTERNAL_PROCESS, type: "REFERENCE_NUMBER" }
      ],
      datekey: uuidv4()
    };
  },

  computed: {
    ...mapGetters({
      getSubjects: "getSubjects",
      getFilterList: "getFilterList",
      getFilteredParts: "getFilteredParts",
      getCapacitiesFiltered: "getCapacitiesFiltered"
    }),

    optionsList() {
      const options = this.options.filter(item =>
        this.itensFilter.includes(item.type)
      );

      return options;
    }
  },

  watch: {
    getFilterList({ currentFilterList }) {
      this.currentFilterList = this.padronizeListData(currentFilterList);
    }
  },

  beforeMount() {
    if (!this.getFilterList.currentFilterList?.length) {
      this.currentFilterList = [
        {
          type: null,
          data: {
            displayText: ""
          },
          id: ""
        }
      ];
    } else {
      this.currentFilterList = this.padronizeListData(
        this.getFilterList.currentFilterList
      );
    }
  },

  methods: {
    ...mapActions(["subjectPublicRequest"]),

    checkSingleFilter(filterIndex) {
      return filterIndex === 0 && this.currentFilterList.length === 1;
    },

    setFilterPartTo(text) {
      this.filterPartTo = text;
    },

    setFilterCapacityTo(text) {
      this.filterCapacityTo = text;
    },

    setFilterSubject: debounce(async function(text, index) {
      this.isFetching[index] = true;
      this.$forceUpdate();
      await this.subjectPublicRequest(text);
      this.isFetching[index] = false;
      this.$forceUpdate();
    }, 500),

    onSelectOption(option, index) {
      this.currentFilterList[index] = {
        type: option,
        data: { displayText: "" }
      };
      this.currentFilterList = [...this.currentFilterList];
    },

    onSelectData(data, index) {
      if (data) {
        this.currentFilterList[index].data = data;
        this.currentFilterList[index].id = uuidv4();
        if (this.$refs[this.datekey]?.[0]?.isActive)
          this.$refs[this.datekey]?.[0].toggle();
      }
    },

    addFilter() {
      this.currentFilterList.push({
        type: null,
        data: { displayText: "" }
      });
    },

    removeFilter(index) {
      if (this.currentFilterList.length > 1)
        this.currentFilterList.splice(index, 1);
    },

    clearFilter(index) {
      this.currentFilterList[index] = { type: null, data: { displayText: "" } };
      this.currentFilterList = [...this.currentFilterList];
    },

    applyFilters() {
      this.onApply(this.currentFilterList);
      this.close();
    },

    checkSelect(actualIndex) {
      const indexTypes = this.currentFilterList.map(filter => filter.type);
      return this.optionsList.filter(filter => {
        const itemIndex = indexTypes.indexOf(filter.type);
        return filter.unique
          ? itemIndex < 0 || itemIndex === actualIndex
          : true;
      });
    },

    close() {
      this.$parent.close();
    },

    padronizeListData(list) {
      return list.map(item => ({
        ...item,
        data: item.data.end
          ? {
              start: new Date(item.data.start),
              end: new Date(item.data.end)
            }
          : item.data
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  background-color: $background-light;
  padding: 10px 15px;
  width: 800px;
  max-width: 90vw;

  .modal-body {
    height: 250px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.list-filter {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input-text {
  flex: 1;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.filter-dropdown {
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 1024px) {
    min-width: 600px;
  }

  .new-filter-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .new-filter {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
}
</style>
